export default __webpack_public_path__ + "static/media/CambridgeManor.034da5c2.jpg";